<main>	
	<router-outlet></router-outlet>
</main>
<eup-toastr-container></eup-toastr-container>
<eup-notification></eup-notification>
<eup-spinner></eup-spinner>
<screenshot-toast></screenshot-toast>
